export const sortAscByKey = (
    array: Array<Record<string, any>>,
    key: string
  ): Array<Record<string, any>> => {
    if (!array) return [];
  
    return array.sort((a, b) => {
      if (a[key] < b[key]) { return -1 }
      if (a[key] > b[key]) { return 1 }
      return 0;
    })
  }